/**
 * Maps heading style keys to their corresponding margin-bottom classes.
 * Used to control vertical spacing for different heading styles in the UI.
 *
 * Example usage:
 *   const spacingClass = headingSpacingMappings["heading-3xl-light"];
 *   // spacingClass = "mb-32 md:mb-40"
 */
// spacing-config.ts

// Spacings
const sizeGaps = {
    "5xl": "mb-18 lg:mb-37",
    "4xl": "mb-20 lg:mb-46",
    "3xl": "mb-22 lg:mb-24",
    "2xl": "mb-22 lg:mb-26",
    xl: "mb-20 lg:mb-28",
    lg: "mb-20 lg:mb-30",
    md: "mb-20 lg:mb-22",
    sm: "mb-20 lg:mb-22"
} as const

type Size = keyof typeof sizeGaps
type Variant = "light" | "regular" | "bold"
type Prefix = "heading" | "trim-heading"

const prefixes: Prefix[] = ["heading", "trim-heading"]
const variants: Variant[] = ["light", "regular", "bold"]

export const headingSpacingMappings: Record<string, string> = Object.fromEntries(
    prefixes.flatMap(prefix =>
        (Object.keys(sizeGaps) as Size[]).flatMap(size =>
            variants.map(variant => {
                const key = `${prefix}-${size}-${variant}` as const
                const gap = sizeGaps[size]
                return [key, gap]
            })
        )
    )
)
